
const techSupportErrorMessageAppend = "A technical issue has been detected, please coordinate with Malayan technical team at ecommerce@malayan.com or call our hotline at (02) 8628-8628.";

export default {
    components: {
        PageContent: () => import("~/components/claims-and-support/claims-form/PageContent"),
    },
    data: () => ({
        isReady: false,
        pageName: "claims-form",
        pageContentPayload: {},
    }),
    methods: {
        async initialize() {
            this.toggleLoaderStatus({ status: true });
            try {
                await new Promise((resolve) => setTimeout(resolve, 1000));
            } catch (error) {
                console.error("Request failed:", error.response?.data || error);
                let errorMessages = [`${techSupportErrorMessageAppend}`];
                this.$store.commit("global/dialog/populateContents", {
                    items: errorMessages,
                });

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    error_id: `1235d450-fabe-4d24-b720-0bb80940d88d`,
                    event: `technical_error`,
                    timestamp: new Date().toISOString(),
                    request_status: error.response?.status || `unknown`,
                    request_path: error.config?.url || `unknown`,
                    error_message: error.message || `unknown`,
                });

                window.InsiderQueue = window.InsiderQueue || [];
                window.InsiderQueue.length = 0;
                window.InsiderQueue.push({
                    type: "custom_event",
                    value: [
                        {
                            event_name: "technical_error",
                            event_parameters: {
                                custom: {
                                    error_id: `1235d450-fabe-4d24-b720-0bb80940d88d`,
                                    timestamp: new Date().toISOString(),
                                    request_status: error.response?.status || `unknown`,
                                    request_path: error.config?.url || `unknown`,
                                    error_message: error.message || `unknown`,
                                },
                            },
                        },
                    ],
                });
                window.InsiderQueue.push({ type: "init" });

                this.scrollToTop();
            } finally {
                setTimeout(() => {
                    this.toggleLoaderStatus({ status: false });
                    this.isReady = true;
                }, 600);
            }
        },
    },
    async mounted() {
        this.scrollToTop();
        await this.initialize();
    },
    head() {
        return {
            title: "Claims Form | Malayan Insurance (Philippines)",
            link: [
                {
                    href: `https://malayan.com${this.$route.fullPath}`,
                },
                {
                    rel: "canonical",
                    href: `https://malayan.com${this.$route.fullPath}`,
                },
            ],
            meta: [
                {
                    name: "keywords",
                    content:
                        "insurance company philippines, non life insurance company, non life insurance company philippines, non life insurer, insurance company in the philippines, affordable travel insurance, affordable travel insurance philippines, budget travel insurance, insurance for budget travel, affordable travel insurance online, vehicle insurance philippines, motor vehicle insurance, motor vehicle insurance philippines, car and motorcycle insurance, car and motorbike insurance, Car insurance philippines, car insurance online application, apply for auto insurance online, comprehensive car insurance philippines, comprehensive car insurance, insurance for motorcycle philippines, comprehensive motorcycle insurance, bike insurance apply online, motorcycle insurance, motorcycle insurance online",
                },
                {
                    hid: "og:title",
                    property: "og:title",
                    content: "The Largest Insurance Company in the Philippines | Malayan Insurance (Philippines)",
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: "Malayan Insurance Philippines is the largest non-life insurer in the country. Protect yourself and your loved ones with our products today.",
                },
                {
                    name: "description",
                    hid: "description",
                    property: "description",
                    content: "Malayan Insurance Philippines is the largest non-life insurer in the country. Protect yourself and your loved ones with our products today.",
                },
                {
                    hid: "og:url",
                    property: "og:url",
                    content: `https://malayan.com${this.$route.fullPath}`,
                },
                {
                    hid: "og:image",
                    property: "og:image",
                    content: "/mico2022-[light].webp",
                },
                {
                    hid: "og:image:alt",
                    property: "og:image:alt",
                    content: "Malayan Insurance",
                },
                {
                    hid: "og:site_name",
                    property: "og:site_name",
                    content: "Malayan Insurance",
                },
                { hid: "og:type", property: "og:type", content: "website" },
                {
                    hid: "og:site_name",
                    property: "og:site_name",
                    content: "Malayan Insurance",
                },
            ],
        };
    },
};
